import { KeyBindController, ShortcutLocation } from '../KeyBindController.ts';
import { createDivIn, setElementOnClick } from '../ui_utils/DomUtils.ts';
export class UIPopup {
    containerClicked(event) {
        if (event.target !== this.container) return;
        this.hide();
    }
    show() {
        this.container.style.display = 'block';
    }
    hide() {
        this.container.style.display = 'none';
    }
    isHidden() {
        return this.container.style.display == 'none';
    }
    setEscapeKeyBind() {
        KeyBindController.bindKey('Escape', ()=>this.hide(), ()=>!this.isHidden(), ShortcutLocation.General);
    }
    removePopup() {
        this.container.style.display = 'none';
        if (this.container.parentElement != undefined) this.container.parentElement.removeChild(this.container);
    }
    constructor(){
        this.container = createDivIn(document.body, 'popup');
        setElementOnClick(this.container, (event)=>this.containerClicked(event));
    }
}
